import { CALL_AVAILABILITY_TYPE, CHAT_AVAILABILITY_TYPE } from 'libs/constants';

const AVAILABILITY_MAJOR_RANK = {
  UNKNOWN: 0,
  CALL_NOW: 1,
  BUSY_ARRANGE_HIGH: 2,
  BUSY_APPOINTMENT_HIGH: 3,
  PHONE_ALERT: 4,
  BUSY_ARRANGE_MEDIUM: 5,
  BUSY_ARRANGE_LOW: 6,
  BUSY_APPOINTMENT_LOW: 7,
  BUSY_MAIL_TAKING_CALLS: 8,
  BUSY_MAIL: 9,
  ARRANGE: 10,
  APPOINTMENT: 11,
  AWAY: 12
};

// abstracts out api availability complexity for UI implementations.
export const getCallAvailabilityTypeByMajorRank = (majorRank) => {
  switch (majorRank) {
    case AVAILABILITY_MAJOR_RANK.UNKNOWN:
    case AVAILABILITY_MAJOR_RANK.CALL_NOW:
    case AVAILABILITY_MAJOR_RANK.PHONE_ALERT:
      return CALL_AVAILABILITY_TYPE.CALL_NOW;

    case AVAILABILITY_MAJOR_RANK.BUSY_MAIL:
    case AVAILABILITY_MAJOR_RANK.BUSY_MAIL_TAKING_CALLS:
      return CALL_AVAILABILITY_TYPE.SEND_MAIL_BUSY;

    case AVAILABILITY_MAJOR_RANK.BUSY_ARRANGE_LOW:
    case AVAILABILITY_MAJOR_RANK.BUSY_ARRANGE_HIGH:
    case AVAILABILITY_MAJOR_RANK.BUSY_ARRANGE_MEDIUM:
      return CALL_AVAILABILITY_TYPE.ARRANGE_CALL_BUSY;

    case AVAILABILITY_MAJOR_RANK.BUSY_APPOINTMENT_LOW:
    case AVAILABILITY_MAJOR_RANK.BUSY_APPOINTMENT_HIGH:
      return CALL_AVAILABILITY_TYPE.ARRANGE_APPOINTMENTS_BUSY;

    case AVAILABILITY_MAJOR_RANK.AWAY:
      return CALL_AVAILABILITY_TYPE.SEND_MAIL_AWAY;

    case AVAILABILITY_MAJOR_RANK.ARRANGE:
      return CALL_AVAILABILITY_TYPE.ARRANGE_CALL_AWAY;

    case AVAILABILITY_MAJOR_RANK.APPOINTMENT:
      return CALL_AVAILABILITY_TYPE.ARRANGE_APPOINTMENTS_AWAY;

    default:
      throw new Error(
        `Availability: No call availability type is mapped for MajorRank=${majorRank}`
      );
  }
};

export const advisorIsBusy = (callAvailabilityId, chatAvailabilityId) => {
  const callBusyTypes = [
    CALL_AVAILABILITY_TYPE.ARRANGE_APPOINTMENTS_BUSY,
    CALL_AVAILABILITY_TYPE.ARRANGE_CALL_BUSY,
    CALL_AVAILABILITY_TYPE.SEND_MAIL_BUSY
  ];

  return (
    callBusyTypes.includes(callAvailabilityId) ||
    chatAvailabilityId === CHAT_AVAILABILITY_TYPE.BUSY
  );
};

export const advisorIsAway = (callAvailabilityId, chatAvailabilityId) => {
  if (advisorIsBusy(callAvailabilityId, chatAvailabilityId)) {
    return false;
  }

  const awayCallTypes = [
    CALL_AVAILABILITY_TYPE.ARRANGE_APPOINTMENTS_AWAY,
    CALL_AVAILABILITY_TYPE.ARRANGE_CALL_AWAY,
    CALL_AVAILABILITY_TYPE.SEND_MAIL_AWAY
  ];

  const awayChatTypes = [
    CHAT_AVAILABILITY_TYPE.ARRANGE_CHAT,
    CHAT_AVAILABILITY_TYPE.CHAT_LATER
  ];

  return (
    awayCallTypes.includes(callAvailabilityId) &&
    awayChatTypes.includes(chatAvailabilityId)
  );
};
